import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR,LOGOUT_USER, LOGOUT_USER_SUCCESS, VERIFY_ADMIN, VERIFY_ADMIN_SUCCESS, VERIFY_ADMIN_FAIL, RESET_STATE, REQUEST_OTP_USER_SUCCESS, REQUEST_OTP_USER_FAIL, REQUEST_OTP_USER, RESET_ACTION_STATE, SWITCH_USER, SWITCH_USER_SUCCESS, SWITCH_USER_FAIL } from './actionTypes';

export const checkLogin = (user, history, rememberMe) => {
    return {
        type: CHECK_LOGIN,
        payload: { user, history, rememberMe }
    }
}

export const loginUserSuccessful = (user) => {
    return {
        type: LOGIN_USER_SUCCESSFUL,
        payload: user
    }
}

export const requestOtpUser = (data) => {
    return {
        type: REQUEST_OTP_USER,
        payload: data
    }
}

export const requestOtpUserSuccess = (data) => {
    return {
        type: REQUEST_OTP_USER_SUCCESS,
        payload: data
    }
}

export const requestOtpUserFail = (error) => {
    return {
        type: REQUEST_OTP_USER_FAIL,
        payload: error
    }
}

export const apiError = (error) => {
    return {
        type: API_ERROR,
        payload: error
    }
}

export const logoutUser = (payload) => {
    return {
        type: LOGOUT_USER,
        payload: payload
    }
}

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {}
    }
}

export const verify_admin = (user) => {
    return {
        type: VERIFY_ADMIN,
        payload: {user}
    }
}
export const verify_adminSuccess = (user) => {
    return {
        type: VERIFY_ADMIN_SUCCESS,
        payload: {user}
    }
}
export const verify_adminFail = (user) => {
    return {
        type: VERIFY_ADMIN_FAIL,
        payload: {user}
    }
}

export const switchUser = (user) => {
    return {
        type: SWITCH_USER,
        payload: user
    }
}
export const switchUserSuccess = (user) => {
    return {
        type: SWITCH_USER_SUCCESS,
        payload: {user}
    }
}
export const switchUserFail = (user) => {
    return {
        type: SWITCH_USER_FAIL,
        payload: {user}
    }
}

export const resetLoginState = () => {
    return {
         type: RESET_STATE,
         payload:{}
    }
}

export const resetLoginActionState = () => {
    return {
         type: RESET_ACTION_STATE,
         payload:{}
    }
}


